import { TYPES } from 'src/common/constants';
import * as client from '../../services/client';
import {
  startLoading,
  stopLoading,
} from './loader';

export const setPropertyWalkThroughFormData = (payload) => ({
  type: TYPES.SET_PROPERTY_WALK_THROUGH_FORM_DATA,
  payload,
});

export const setPropertyWalkThroughFormNextStep = () => ({
  type: TYPES.SET_PROPERTY_WALK_THROUGH_FORM_NEXT_STEP,
});

export const setPropertyWalkThroughFormStep = (step) => ({
  type: TYPES.SET_PROPERTY_WALK_THROUGH_FROM_STEP,
  payload: {
    step,
  },
});

export const exitPropertyWalkThroughForm = () => ({
  type: TYPES.EXIT_PROPERTY_WALK_THROUGH_FORM,
});

export const setPropertyWalkThroughFormIsVisible = (payload) => ({
  type: TYPES.SET_PROPERTY_WALK_THROUGH_FORM_IS_VISIBLE,
  payload,
});

export const saveConfigType = (data) => (dispatch) => {
  return client.saveConfigType(data).then((response) => {
    if (response.status === 200 || response.ok) {
      response.json().then((responsejson) => {
        dispatch(
          setPropertyWalkThroughFormData({
            configTypeSaved: responsejson.data[0],
            walkthroughId: responsejson.data[0].id,
          })
        );
      });
    } else {
      // alert('some thing went wrong in saving cofig type')
    }
  });
};

export const updateConfigType = (data) => (dispatch) => {
  dispatch(setPropertyWalkThroughFormData({ copyFromSuiteIdApiCalling: true }));
  return client
    .updateConfigType(data)
    .then((response) => {
      if (response.status === 200 || response.ok) {
        dispatch(
          setPropertyWalkThroughFormData({ copyFromSuiteIdApiCalling: false })
        );
        response.json().then((responsejson) => {
          if (responsejson && responsejson.statusCode === 200) {
            dispatch(setPropertyWalkThroughFormData({ checkList: [] }));
            dispatch(setPropertyWalkThroughFormStep(1));
          } else {
            alert('some thing went wrong in updating cofig walkthrough.');
          }
        });
      }
    })
    .catch(() => {
      dispatch(
        setPropertyWalkThroughFormData({ copyFromSuiteIdApiCalling: false })
      );
    });
};

export const saveCopyFromExisting = (data) => (dispatch) => {
  return client.saveCopyFromExisting(data).then((response) => {
    if (response.status === 200 || response.ok) {
      response.json().then((responsejson) => {
        dispatch(setPropertyWalkThroughFormNextStep());
        dispatch(
          setPropertyWalkThroughFormData({
            copyFromSuiteIdApiCalling: false,
            FromWalkthroughsId: null,
            ToWalkthroughsId: null,
            checkList: [],
          })
        );
      });
    } else {
      alert('some thing went wrong in saving cofig type');
    }
  });
};

export const fetchConfigureTypeWalkThroughData =
  (walkThroughId, type) => (dispatch) => {
    dispatch(startLoading());
    return client
      .getWalkthroughDataByWalkthroughId(walkThroughId)
      .then((response) => {
        if (response.status === 200 || response.ok) {
          response.json().then((responsejson) => {
            dispatch(stopLoading());
            dispatch(
              setPropertyWalkThroughFormData({
                configTypeSaved: responsejson.data[0],
              })
            );
          });
        }
      });
  };

export const getAreaAndSubAreaStatus = (walkThroughId) => (dispatch) => {
  return client.getAreaAndSubAreaStatus(walkThroughId).then((response) => {
    if (response.status === 200 || response.ok) {
      response.json().then((responsejson) => {
        dispatch(
          setPropertyWalkThroughFormData({ areaAndSubAreaStatus: responsejson })
        );
      });
    }
  });
};